import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import CheckBox from '../../../shared/Fields/CheckBox';
import SelectBox from "../../../shared/Fields/SelectBox";
import GQPopup from '../../../shared/components/GQPopups/GQPopup';
import AuthoritiesData from '../../../helpers/authorities';
import Constant from "../../../helpers/constant";
import { useSelector } from 'react-redux';


function FullTextResultInfoModal(props) {

    const { openOrClosed, resInfo, cancel, save } = props;
    const authorities = AuthoritiesData.getAuthorities(true);
    const [tempInfo, setTempInfo] = useState({ ...(resInfo || {}) });
    const toggle = useSelector(state => state.setToggle.toggle);

    const cancelThis = () => {
        setTempInfo({ ...(resInfo || {}) });
        cancel();
    };

    useEffect(() => {
        if (openOrClosed) {
            setTempInfo({ ...(resInfo || {}) });
        }
    }, [openOrClosed, resInfo]);

    const updateTempInfo = (field, value) => {
        setTempInfo((prevState) => ({
            ...prevState,
            [field]: value
        }));
    };

    
    return (
        <GQPopup
            show={openOrClosed}
            close={() => cancelThis()}
            styles={{ width: '640px', maxWidth: '95vw' }}
            innerHtml={
                <div>
                    <h4 className={'subHeading margin15 titleFont'}>Representative Document in Patent Families</h4>
                    <div className='margin15'>
                        <CheckBox
                            onChange={() => updateTempInfo('isAuthoritySorting', !tempInfo.isAuthoritySorting)}
                            checked={tempInfo.isAuthoritySorting}
                        />
                        <label className={'checkBoxContent bodyText cursorPointer ml-0 mr-3'}>Apply this preferred authority order</label>
                    </div>
                    <div className='margin15'>

                        <SelectBox
                            value={tempInfo.configure1}
                            items={authorities}
                            className={'mr-2 ml-2'}
                            onChange={(e) => updateTempInfo('configure1', e.target.value)}
                            disabled={!tempInfo.isAuthoritySorting}
                            smallSelectBox={true}
                            style={{ color: toggle ? 'white' : 'black' }}
                        />
                        <SelectBox
                            value={tempInfo.configure2}
                            items={authorities}
                            onChange={(e) => updateTempInfo('configure2', e.target.value)}
                            className={'mr-2 ml-2'}
                            disabled={!tempInfo.isAuthoritySorting}
                            smallSelectBox={true}
                        />
                        <SelectBox
                            value={tempInfo.configure3}
                            items={authorities}
                            onChange={(e) => updateTempInfo('configure3', e.target.value)}
                            className={'mr-2 ml-2'}
                            disabled={!tempInfo.isAuthoritySorting}
                            smallSelectBox={true}
                        />
                        <SelectBox
                            value={tempInfo.configure4}
                            items={authorities}
                            onChange={(e) => updateTempInfo('configure4', e.target.value)}
                            className={'mr-2 ml-2'}
                            disabled={!tempInfo.isAuthoritySorting}
                            smallSelectBox={true}
                        />
                        <SelectBox
                            value={tempInfo.configure5}
                            items={authorities}
                            onChange={(e) => updateTempInfo('configure5', e.target.value)}
                            className={'mr-2 ml-2'}
                            disabled={!tempInfo.isAuthoritySorting}
                            smallSelectBox={true}
                        />
                    </div>
                    <div className='mb-1'></div>
                    <div className='margin15'>
                        <CheckBox
                            onChange={() => updateTempInfo('isDateSorting', !tempInfo.isDateSorting)}
                            checked={tempInfo.isDateSorting}
                        />
                        <label className={'bodyText ml-0 mr-3'}>Select documents with</label>
                    </div>
                    <div className='margin15'>

                        <SelectBox

                            value={tempInfo.dateSortingDirection}
                            items={Constant.dateSortingDirection}
                            onChange={(e) => updateTempInfo('dateSortingDirection', e.target.value)}
                            className={'mr-2 ml-2'}
                            disabled={!tempInfo.isDateSorting}
                        />
                        <SelectBox
                            value={tempInfo.dateSortingField}
                            items={Constant.dateSortingField}
                            onChange={(e) => updateTempInfo('dateSortingField', e.target.value)}
                            className={'mr-2 ml-2'}
                            disabled={!tempInfo.isDateSorting}
                        />
                    </div>
                    <div className='margin15'>
                        <Button className={'submitButtonClass float-right ml-2'} id='mergeSubmit' onClick={() => { save(tempInfo); }}>Apply</Button>
                        <Button className={'cancelButtonClass float-right'} id='mergeCancel' onClick={() => cancelThis()}>Cancel</Button>
                    </div>
                </div>
            }
        />
    );
}

export default FullTextResultInfoModal;